'use client';

import { ChangeEvent } from 'react';
import { RiSearchFill } from 'react-icons/ri';
import { twJoin } from 'tailwind-merge';

import * as Input from '@/components/Input';
import { usePageTextContent } from '@/context/pageTextContent';

export type NearInputProps = {
  onChange(value: string): void;
  value: string;
};

export function NearInput({ onChange, value }: NearInputProps) {
  const { content } = usePageTextContent<SearchPageContent>();

  const { searchFieldPlaceholder } = content;

  const onNearInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="flex w-full px-10">
      <Input.Root className="flex-1 bg-white shadow-[0px_5px_15px_#00000029]">
        <Input.Control
          name="near"
          className={twJoin(
            'flex w-full rounded-lg border-none py-2',
            'placeholder-gray-550 placeholder:font-light',
          )}
          onChange={onNearInputChange}
          value={value}
          placeholder={searchFieldPlaceholder}
        />

        <Input.Suffix className="pr-4">
          <RiSearchFill className="text-zmyle-primary size-5" />
        </Input.Suffix>
      </Input.Root>
    </div>
  );
}
